(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('GeodataDialogController', GeodataDialogController);

    GeodataDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Geodata'];

    function GeodataDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Geodata) {
        var vm = this;
        vm.geodata = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:geodataUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.geodata.id !== null) {
                Geodata.update(vm.geodata, onSaveSuccess, onSaveError);
            } else {
                Geodata.save(vm.geodata, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
